import emitter from 'tiny-emitter/instance';

/**
 * Objet encapsulant notre gestion de scroll
 * Si on doit passer par un autre librairie, les actions de base seront mieux centralisées ici
 */
class BulbScroll{

    constructor(bulb){
        // console.debug('BulbScroll : Construct');
        this.bulb = bulb;
        this.init();
    }

    /**
     * Init notre scrollManager ainsi que tous les event qu'on souhaite au scroll
     */
    init(){

        window.addEventListener('scroll', () => {
            emitter.emit('bulbScroll::scrolling');
            // on va checker si les modules sont présent dans la page
        });
    }


    destroy(){
        //console.debug('BulbScroll : destroy');
        if(this.scrollManager) {
            this.scrollManager.destroy();
            this.scrollManager = null;
        }
    }


}


export default BulbScroll;



// WEBPACK FOOTER //
// ./scripts/core/bulbScroll.js